import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { convertBase64toFileAndDownload } from 'src/app/shared/functions/FileDownloader';
import { ActionHistoryQueueService } from '../../action-history-queue.service';

@Component({
  selector: 'app-modal-calendar',
  templateUrl: './modal-calendar.component.html',
  styleUrls: ['./modal-calendar.component.scss']
})
export class ModalCalendarComponent implements OnInit {
  date;
  loading = false;
  form: FormGroup;

  constructor(private datepipe: DatePipe, private service: ActionHistoryQueueService, public dialogRef: MatDialogRef<ModalCalendarComponent>) {
    this.form = new FormGroup({
      startDate: new FormControl(null, Validators.required),
      endDate: new FormControl(null, Validators.required),
    });
  }

  ngOnInit(): void {
  }

  onChange(result: any): void {
    this.form.get('startDate').setValue(this.datepipe.transform(result[0], 'yyyy-MM-dd'));
    this.form.get('endDate').setValue(this.datepipe.transform(result[1], 'yyyy-MM-dd'));
  }

  download() {
    this.loading = true;
    this.service.reportActionHistory(this.form.get('startDate').value, this.form.get('endDate').value).subscribe((res: any) => {
      convertBase64toFileAndDownload('xlsx', res.file,res.name);      
      this.loading = false;
      this.close();
    }, (err: any) => {
      this.loading = false;
      console.error('Erro ao gerar relatório', err);
    });
  }

  close(): void {
    this.dialogRef.close();
  }

}
